module.exports = __webpack_public_path__ + "fb4c8267f3f82499c624aeb22843d063.svg";